(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lojas-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lojas-product-offer')) {
    customElements.define('lojas-product-offer', class extends HTMLElement {
      connectedCallback() {
        try { this.variants = JSON.parse(this.querySelector('[data-lp-variants]')?.textContent || '[]') || []; } catch { this.variants = []; }
        this.formatter = new Intl.NumberFormat('es-CO', {maximumFractionDigits: 2});
        this.formatPrice = cents => '$' + this.formatter.format(Number(cents) / 100);
        this.info = this.closest('product-info');
        this.onChange = () => window.setTimeout(() => this.update(), 80);
        this.info?.addEventListener('change', this.onChange);
        this.observer = new MutationObserver(() => this.update());
        if (this.info) this.observer.observe(this.info, {childList: true, subtree: true, attributes: true, attributeFilter: ['value']});
        this.update();
      }
      disconnectedCallback() { this.info?.removeEventListener('change', this.onChange); this.observer?.disconnect(); }
      update() {
        const id = document.getElementById(`product-form-${this.dataset.sectionId}`)?.querySelector('[name="id"]')?.value;
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant || this.lastVariantId === variant.id) return;
        this.lastVariantId = variant.id;
        const savings = Math.max(0, Number(variant.compare_at_price || 0) - Number(variant.price));
        const put = (selector, value) => { const node = this.querySelector(selector); if (node) node.textContent = value; };
        put('[data-lp-price]', this.formatPrice(variant.price));
        const compare = this.querySelector('[data-lp-compare]');
        if (compare) { compare.hidden = !savings; if (savings) compare.textContent = this.formatPrice(variant.compare_at_price); }
        const savingsRow = this.querySelector('[data-lp-savings]');
        if (savingsRow) { savingsRow.hidden = !savings; if (savings) { put('[data-lp-saving-amount]', this.formatPrice(savings)); put('[data-lp-saving-percent]', String(Math.round(savings * 100 / variant.compare_at_price))); } }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
